import axios from 'axios';
import { AddressCoordinatesSearchQueryResponse, AddressSuggestion, AddressTypes } from '../../../types/models/address/address.types';
import { UseAddressAutocompleteQueryParams } from './useAddressAutocomplete.types';
import departements from '../../../assets/json/departements-region.json'

export const ADDRESS_AUTOCOMPLETE_QUERY_KEY = 'ADDRESS_AUTOCOMPLETE';

export const queryAddressAutocomplete = async (
  address: string,
  params?: UseAddressAutocompleteQueryParams
) => {
  const { data } = await axios.get(
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(address)}.json`,
    {
      params: {
        autocomplete: true,
        access_token:
          'pk.eyJ1IjoieWFjaW5lbGVucyIsImEiOiJjbGlvYjM2aHQwZTVzM2ZwY2RmbXhydjhxIn0.YVjskQUq6YwvpN2M14iVfg',
        language: 'fr',
        session_token: '06cfdd8d-38cb-4391-8889-a7b674200a1z',
        proximity: 'ip',
        types: params?.types || AddressTypes.Address,
        ...params
      },
      transformResponse: (response) => {
        const { features } = JSON.parse(response) as AddressCoordinatesSearchQueryResponse;
        return features.map((suggestion) => {
          const num_departement = suggestion.context?.find((item) => item.id.includes('region'))?.short_code?.replace('FR-', '')
          const postalCode = suggestion.context?.find((item) => item.id.includes('postcode'))?.text
          const city = suggestion.context?.find((item) => item.id.includes('place'))?.text
          const department = departements.find((res) => res.num_dep.toString() == num_departement)?.dep_name
          const region = departements.find((res) => res.num_dep.toString() == num_departement)?.region_name
          const address = suggestion.address ? `${suggestion.address} ${suggestion.text}` : suggestion.text
          const [longitude, latitude] = suggestion.center
          return ({
            address,
            fullAddress: suggestion.place_name,
            city,
            postalCode,
            department,
            department_code: num_departement,
            region,
            region_code: num_departement,
            coordinates: {
              latitude,
              longitude
            }
          })
        }) as AddressSuggestion[]
        // return suggestions.map((suggestion: any) => ({
        //   address: suggestion.address_line1,
        //   fullAddress: suggestion.full_address,
        //   city: suggestion.place,
        //   postalCode: suggestion.postcode,
        //   department: suggestion.region,
        //   department_code: suggestion.region_code,
        //   region_code: suggestion.region_code,
        //   short_code: suggestion.short_code,
        // })) as AddressSuggestion[];
      },
    }
  );

  return data;
};
